var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[_c('el-row',{staticClass:"h-full w-full"},[_c('el-col',{staticClass:"h-full",attrs:{"span":24}},[_c('div',{ref:"ysplayer",class:[_vm.className, 'w-full', 'h-full']})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }